import {ICase, IUser} from '@service-and-repairs/awpintegrationlib';
import {GetServiceOrderRequest} from "./get-service-order-request";
import {AwpDmsInterfaceFactoryUtils} from "../../rest-api/awp-dms-interface-factory-utils";
import {GetServiceOrderRequestBody} from "./get-service-order-request-body";

export class AwpDmsInterfaceGetServiceOrderRequestFactory {

  createRequest(user: IUser, serviceCase: ICase): GetServiceOrderRequest {
    const request = new GetServiceOrderRequest();
    request.functionalHeader = AwpDmsInterfaceFactoryUtils.createFunctionalHeader(serviceCase);
    request.technicalHeader = AwpDmsInterfaceFactoryUtils.createTechnicalHeaderInRequest(
      'awp-dms-get-service-order-request',
      '1.0.1'
    );
    request.userInformation = AwpDmsInterfaceFactoryUtils.createUserInformation(user);
    request.body = this.createRequestBody(serviceCase);
    return request;
  }

  private createRequestBody(serviceCase: ICase): GetServiceOrderRequestBody {
    const body = new GetServiceOrderRequestBody();
    body.dmsServiceOrderId = serviceCase.getDmsOrderNumber();
    return body;
  }
}

